var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sc-message--json",
      class: { right: _vm.right },
      style: Object.assign({}, _vm.messageColors, _vm.extendedStyle || {}),
    },
    [
      _vm.message.raw.replyTo && !_vm.replyMode
        ? _c("QuoteMessage", { attrs: { message: _vm.message.raw.replyTo } })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "json-preview-container" }, [
        _c(
          "div",
          { staticClass: "json-header" },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("code")]),
            _vm._v(" "),
            _c("span", { staticClass: "json-title" }, [
              _vm._v("Desteklenmeyen Mesaj Türü"),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "view-details-btn",
                attrs: { size: "small", type: "link" },
                on: { click: _vm.openJsonModal },
              },
              [_vm._v("\n                Detayları Gör\n            ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "json-preview-content" },
          [
            _vm._l(_vm.getPreviewData(), function (value, key) {
              return _c("div", { key: key, staticClass: "json-preview-item" }, [
                _c("span", { staticClass: "json-key" }, [
                  _vm._v(_vm._s(key) + ":"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "json-value" }, [
                  _vm._v(_vm._s(_vm.formatPreviewValue(value))),
                ]),
              ])
            }),
            _vm._v(" "),
            _vm.hasMoreData
              ? _c("div", { staticClass: "json-more-indicator" }, [
                  _vm._v(
                    "\n                ... ve " +
                      _vm._s(_vm.getTotalKeysCount() - 3) +
                      " alan daha\n            "
                  ),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "json-meta-container" }, [
        _vm.message.data.meta
          ? _c(
              "span",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: _vm.formatDate(_vm.message),
                      followCursor: true,
                      placement: "top",
                    },
                    expression:
                      "{\n                content: formatDate(message),\n                followCursor: true,\n                placement: 'top',\n            }",
                  },
                ],
                staticClass: "sc-message-meta-new",
                style: { color: _vm.messageColors.color },
              },
              [_vm._v(_vm._s(_vm.metaShorter(_vm.message.data.meta)))]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.showJsonModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Mesaj Detayları (JSON)",
                showFooter: false,
                xlarge: "",
              },
              on: {
                cancel: function ($event) {
                  _vm.showJsonModal = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "json-modal-content" },
                [
                  _c("v-jsoneditor", {
                    attrs: { options: _vm.jsonEditorOptions, height: "500px" },
                    model: {
                      value: _vm.jsonData,
                      callback: function ($$v) {
                        _vm.jsonData = $$v
                      },
                      expression: "jsonData",
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }